import React, { useState, useEffect } from "react";
import SideBar from "../../../../components/SideBar";
import Navbar from "../../../../components/Navbar";
import { API_URL } from "../../../../constants";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import * as Yup from "yup";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "80px",
    overflow: "scroll",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white",
    ":hover": {
      backgroundColor: "red",
      color: "white",
    },
  }),
};

const AddPRTemplate = () => {
  const initialFormData = {
    Name: "",
    Description: "",
    IsInActive: 1,
    lines: [
      {
        LineNo: 1,
        QuestionMasterID: "",
        Sequence: "1",
      },
    ],
  };

  const navigate = useNavigate();

  const [QuesDataOption, setQuesDataOption] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [tableData, setTableData] = useState([]); // Define tableData state
  const [prTempMatser, setPrtempMaster] = useState("");

  useEffect(() => {
    fetchPRTemp();
  }, []);

  const fetchPRTemp = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}appraisal-template-master`
      );
      const data = response?.data?.data?.templates;

      const quesdata = response?.data?.data?.questions;
      setQuesDataOption(
        quesdata.map((ques) => ({
          value: ques.value,
          label: ques.text,
        }))
      );
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  useEffect(() => {
    if (prTempMatser !== "") {
      fetchTempMasterID(prTempMatser.ID);
    }
  }, [prTempMatser]);

  const fetchTempMasterID = async (id) => {
    setLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}appraisal-template-master/${id}`
      );
      if (response.status === 200) {
        setFormData(response?.data?.data?.template);
        setTableData(response?.data?.data?.template_question);
      } else {
        console.error("Job not found with ID:", id);
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
    } finally {
      setLoading(false);
    }
  };

  const schema = Yup.object().shape({
    Name: Yup.string().required('Name is required'),
    Description: Yup.string(),
    IsInActive: Yup.number()
      .required('IsInActive is required')
      .oneOf([0, 1], 'Invalid value for IsInActive'),
    lines: Yup.array()
      .of(
        Yup.object().shape({
          QuestionMasterID: Yup.number().typeError("QuestionMasterID is required").required('QuestionMasterID is required').nullable(),
          Sequence: Yup.string().required('Sequence is required'),
        })
      )
      .min(1, 'At least one line is required'),
  });
  const handleTempLineSelectChange = (option, name, index) => {
    const updatedLines = formData.lines.map((item, idx) =>
      idx === index ? { ...item, [name]: option.value } : item
    );
  
    setFormData((prevFormData) => ({
      ...prevFormData,
      lines: updatedLines,
    }));
  
    // Validate the specific field
    if (option.value !== "") {
      validateField(`lines[${index}].${name}`, option.value);
    }
  
    // Validate lines for minimum required questions
   
  };
  
 
  
  const validateField = async (fieldName, updatedData) => {
    try {
      const isNestedField = fieldName.includes('[');
      if (isNestedField) {
        const [parentField] = fieldName.split('[');
        const nestedData = { [parentField]: formData[parentField] };
  
        const fieldPath = fieldName.replace(/\[(\d+)\]/, '.$1');
        const parts = fieldPath.split('.');
        let temp = nestedData;
        while (parts.length > 1) {
          const part = parts.shift();
          temp = temp[part];
        }
        temp[parts[0]] = updatedData;
  
        await schema.validateAt(fieldPath, nestedData);
      } else {
        await schema.validateAt(fieldName, { [fieldName]: updatedData });
      }
  
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[fieldName];
        return newErrors;
      });
    } catch (err) {
      if (err.path === fieldName) {
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: err.message }));
      } else {
        console.error('Unexpected validation error structure:', err);
      }
    }
  };
  const handleInputChange = async (event) => {
    const { name, value } = event.target;
  
    // Update form data
    setFormData((prev) => ({ ...prev, [name]: value }));
  
    // Validate the field after update
    if (value !== "") {
      await validateField(name, value);
    } else {
      // If the value is empty, keep the error
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "This field is required" }));
    }
  };
  
  const handleTempLineChange = async (e, index) => {
    const { name, value } = e.target;
    const updatedLines = formData.lines.map((item, idx) =>
      idx === index ? { ...item, [name]: value } : item
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      lines: updatedLines,
    }));
  
    // Validate the field after the change, but don't clear the error immediately
    if (value !== "") {
      await validateField(name, value);
    } else {
      // If the value is empty, keep the error
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "This field is required" }));
    }
  };
  
 
  
  const handleAddQuestionLine = () => {
    // Ensure there's at least one filled row before adding a new one
    const currentRow = formData.lines[formData.lines.length - 1];
    if (currentRow && currentRow.QuestionMasterID === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }
  
    // Add a new line only if there's at least one valid row
    setFormData((prevState) => ({
      ...prevState,
      lines: [
        ...prevState.lines,
        {
          LineNo: prevState.lines.length + 1,
          QuestionMasterID: "",
          Sequence: prevState.lines.length + 1,
        },
      ],
    }));
  };
  
  const handleDeleteTempLine = (index) => {
    // Ensure that there is always at least one row remaining
    if (formData.lines.length <= 1) {
      toast.error("You must have at least one Question.", {
        position: "top-right",
      });
      return;
    }
  
    const updatedLines = formData.lines.filter((_, idx) => idx !== index);
    setFormData((prevFormData) => ({
      ...prevFormData,
      lines: updatedLines,
    }));
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await schema.validate(formData, { abortEarly: false });
     
      const response = await PostServiceCaller(
        `${API_URL}appraisal-template-master`,
        formData,
        "post"
      );

      // Handle the API response
      if (response.status === 200) {
        setLoading(false);
        toast.success("PR Template created successfully!");
        fetchPRTemp();
        setTableData([]);
        navigate("/appraisal-template-masters");
      } else {
        toast.error("PR Template not created!");
      }
    } catch (validationErrors) {
      const errorObject = {};
      validationErrors.inner.forEach((err) => {
        errorObject[err.path] = err.message;
      });
      setErrors(errorObject);
      setLoading(false)
      
    }
  };




  return (
    <>

      <div className="Container" >
        <form
        id="formOne"
          className="rounded bg-white mx-3 mt-3 px-2 pt-3"
          onSubmit={handleSubmit}
        >
          <div className="row ">
            <div className="col-4">
              <div className="mb-3">
                <label htmlFor="Code" className="form-label">
                  Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="Code"
                  disabled
                />
              </div>
            </div>
            <div className="col-4">
              <div className="mb-3">
                <label htmlFor="Name" className="form-label">
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.Name ? "is-invalid" : ""
                    }`}
                  name="Name"
                  value={formData.Name}
                  onChange={handleInputChange}
                />
                {errors.Name && (
                  <div className="invalid-feedback">{errors.Name}</div>
                )}
              </div>
            </div>
            <div className="col-4">
              <div className="mb-3">
                <label htmlFor="Description" className="form-label">
                  Description
                </label>
                <textarea
                  className="form-control"
                  name="Description"
                  value={formData.Description}
                  onChange={handleInputChange}
                ></textarea>
              </div>
            </div>
          </div>

          <div>
            <h4>Template Questions</h4>
            <div>
              <div className="table-responsive poc-head rounded mt-2">
                <button
                  type="button"
                  onClick={handleAddQuestionLine}
                  className="custom-btn mb-2 pull-right "
                >
                  <i className="fa fa-plus"></i>&nbsp;Add
                </button>
                <Table
                  style={{ background: "#ECECEC !important" }}
                  className="table table-bordered"
                >
                  <thead id="thcolor" className="text-center align-middle">
                    <tr>
                      <th>Sr. No.</th>
                      <th>
                        Question
                      </th>
                      <th>
                        Sequence
                      </th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="text-center align-middle">
                    {formData.lines.map((tempLine, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <Select
                            options={QuesDataOption}
                            value={QuesDataOption.find(
                              (option) =>
                                option.value === tempLine.QuestionMasterID
                            )|| null}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 1050,
                              }),
                            }}
                            name="QuestionMasterID"
                            onChange={(selectedOption, action) =>
                              handleTempLineSelectChange(
                                selectedOption,
                                action.name,
                                index
                              )
                            }
                            placeholder="Select Question"
                          // isClearable
                          />


                          {errors?.[`lines[${index}].QuestionMasterID`] ? <span className="error">
                            {errors?.[`lines[${index}].QuestionMasterID`]}
                          </span> : ''}
                        </td>
                        <td>
                          <input
                            type="number"
                            name="Sequence"
                            className="form-control"
                            value={tempLine.Sequence}
                            onChange={(e) => handleTempLineChange(e, index)}
                          />


                          {/* {errors?.[`lines[${index}].Sequence`] ? <span className="error">
                            {errors?.[`lines[${index}].Sequence`]}
                          </span> : ''} */}

                        </td>
                        <td className="text-center align-middle">
                          <div
                            type="button"
                            onClick={() => handleDeleteTempLine(index)}
                          >
                            <i
                              className="bi bi-trash"
                              style={{ fontSize: "1.2rem" }}
                            ></i>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="text-end">
              {/* <button className="custom-btn mt-4 me-2">Submit</button> */}


              <button
                type="button"
                className="btn-info me-2"
                onClick={() => navigate("/appraisal-template-masters")}
              >
                Cancel
              </button>

              <button
                disabled={loading ? true : false}
                className="custom-btn "
                onClick={handleSubmit}
              >
                {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </div>

    </>
  );
};

export default AddPRTemplate;
